import { toast } from 'react-toastify';
import { ApiError } from '../api/apiError';
import AppToasterWithErrorMessages from '../components/AppToasterWithErrorMessages';
import { history } from './history';

export function reportApiError(error: ApiError, actionType: string) {
    if (actionType.startsWith('calendarSlice/')) {
        toast.error(error.message);
    } else if (error.status === 401) {
        history.push('/unauthorized');
    } else if (actionType === 'requestSlice/submitRequestAsync/rejected') {
        const message = "There's been a problem associating your contact details with this request. Please contact us at RCSIPortal@rcsi.com.";
        toast.error(message);
        history.push(`/server-error/${message}`);
    } else if (error.status === 404 || error.status === 500) {
        history.push('/server-error');
    } else if (error.errors.length > 1) {
        AppToasterWithErrorMessages(error.errors);
    } else {
        toast.error(error.message);
    }
}
